import { render, staticRenderFns } from "./PricingComponent.vue?vue&type=template&id=0b9a36be&scoped=true&"
import script from "./PricingComponent.vue?vue&type=script&lang=js&"
export * from "./PricingComponent.vue?vue&type=script&lang=js&"
import style0 from "./PricingComponent.vue?vue&type=style&index=0&id=0b9a36be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a36be",
  null
  
)

export default component.exports